import { render } from "./IconBox.vue?vue&type=template&id=25569421&scoped=true"
const script = {}

import "./IconBox.vue?vue&type=style&index=0&id=25569421&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25569421"]])

export default __exports__